import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import Modal from '../../../../components/Modal';
import { useDashboardContext } from '../../context';
import { useGlobalContext } from '../../../../globalContext';
import CustomToast from '../../../../components/Toast';
import ConfirmationModal from '../../../../components/ConfirmationPopUp';
import success from '../../../../assets/images/success.png';
import { faPlusSquare } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';

const SendMessage = ({fromClassList}) => {
  const {
    sendEmailModal,
    setSendEmailModal,
    setSlectedStudents,
    setIntialRomovingSelectedStudents,
    setIntialAddingSelectedStudents,
    setSelectRecipient,
    getAllStudents,
    slectedStudents,
    sendMessageHandler,
    selectRecipient,
    successNotification,
    setSuccessNotification
  } = useDashboardContext();

  const {getAllAlertsAsync} = useGlobalContext();
  const [subject, setSubject] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [successMsg, setSuccessMsg] = React.useState('');
  const location = useLocation();

  const sendMessageCloseHandler = () => {
    setSendEmailModal(false);
    setSlectedStudents([]);
    setMessage('');
    setSubject('');
    setIntialRomovingSelectedStudents([]);
    setIntialAddingSelectedStudents([]);
  };

  const selectRecipientHandler = () => {
    if(!fromClassList)
    {
      setSendEmailModal(!sendEmailModal);
      setSelectRecipient(!selectRecipient);
      getAllStudents();
    }
  };

  const sendHandler = async () => {
    if (slectedStudents.length > 0) {
      if (subject === '' || message === '') {
        CustomToast('Please enter subject and message', 'error');
        return;
      }
      const data = {
        subject: subject,
        message: message,
        recipientIds: slectedStudents.map((obj) => obj.studentId)
      };

      const recepients = slectedStudents
        .map((student) => {
          return student.fName + ' ' + student.lName;
        })
        .join(', ');
      setSuccessMsg(`Message Successfully sent to ${recepients}`);

      try {
        await sendMessageHandler(data);
        setSlectedStudents([]);
        setIntialAddingSelectedStudents([]);
        const isSentMessages = location.pathname.endsWith('/sent');
        if (isSentMessages) {
          getAllAlertsAsync(2);
        }
      } catch (error) {
        console.log(error);
      }
      setSubject('');
      setMessage('');
      setSendEmailModal(false);
    } else {
      CustomToast('Please select recipients', 'error');
    }
  };

  const removeSelectedStudents = (student) => {
    setSlectedStudents((prevSelectedStudents) => {
      return prevSelectedStudents.filter((s) => s !== student);
    });
  };

  return (
    <>
      <Modal
        contentWidth="1000px"
        isOpen={sendEmailModal}
        titleName={'Send Message'}
        onClose={sendMessageCloseHandler}>
        <div className="row">
          <div className="col-lg-6 mb-3">
            <label className="form-label">To</label>
            <div
              onClick={selectRecipientHandler}
              className="form-control selected-emails d-flex flex-wrap gap-2 align-items-center overflow-auto">
              {slectedStudents.map((student, index) => (
                <span key={index}>
                  {`${student.fName} ${student.lName}`}
                  <FontAwesomeIcon
                    onClick={(event) => {
                      event.stopPropagation();
                      removeSelectedStudents(student);
                    }}
                    icon={faTimesCircle}
                  />
                </span>
              ))}
            </div>
          </div>
          <div className="col-lg-6 mb-3">
            <label className="form-label">Subject</label>
            <input
              value={subject}
              onChange={(event) => setSubject(event.target.value)}
              type="text"
              placeholder=""
              className="form-control"
            />
          </div>
          <div className={`col-lg-6 ${fromClassList?'':'d-none'}`}>
            <div className='d-flex justify-content-end' onClick={()=> {setSelectRecipient(!selectRecipient), getAllStudents();}}>
              <span className='mr-1'><FontAwesomeIcon icon={faPlusSquare} /></span>
              <span>Select Recipients</span>
            </div>
          </div>
          <div className="col-12 mb-3">
            <label className="form-label">Message</label>
            <textarea
              value={message}
              onChange={(event) => setMessage(event.target.value)}
              className="form-control"
              id="exampleFormControlTextarea1"
              rows="5"></textarea>
          </div>
          <div className="col-12 d-flex justify-content-end">
            <button onClick={sendMessageCloseHandler} className="btn btn-castleGray me-2">
              Cancel
            </button>
            <button onClick={sendHandler} className="btn btn-castleRed">
              Send
            </button>
          </div>
        </div>
      </Modal>
      <ConfirmationModal
        isOpen={successNotification}
        onClose={() => {
          setSuccessNotification(false);
          setSuccessMsg('');
        }}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={successMsg ? successMsg : 'Reply message successfully sent'}
        cancelButton={'Ok'}
        showIcon={true}
        icon={success}
        successNotification={successNotification}
        onSave={() => {}}
      />
    </>
  );
};

SendMessage.propTypes={
  fromClassList : PropTypes.bool
};
export default SendMessage;
